import { StyledHr } from "./HorizontalLine.styles";

function HorizontalLine(props) {
  return <StyledHr className={props.className} />;
}

export default HorizontalLine;
